import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    payList: [],
};
const getters = {
    getPay: state => state.payList

};

const mutations = {
    PAY_INFO(state, data) {
        state.payList = data
    }
};

const actions = {
    getPay({commit}) {
        axiosGet(`crm/pay/status`).then((response) => {
            commit('PAY_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
